// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import styled, { keyframes } from 'styled-components';

const getHeightVal = (aspectRatioObj, variation, heightVal) => {
  const { aspectRatioD, aspectRatioT, aspectRatioM } = !isEmpty(aspectRatioObj) && aspectRatioObj;
  const commonStyle = `
  height: 100%;
`;
  if (variation === 'MOBILE' && aspectRatioM) {
    return `${commonStyle}`;
  }
  if (variation === 'TABLET' && aspectRatioT) {
    return `${commonStyle}`;
  }
  if (variation === 'DESKTOP' && aspectRatioD) {
    return `${commonStyle}`;
  }
  return `
  height: ${heightVal ? `${heightVal}px` : `100%`};
  max-height: ${heightVal ? `${heightVal}px` : `100%`};
`;
};

const shimmer = keyframes`
  0% {
  background-position: 200% 0;

  }
  50% {
    background-position: 0 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const TileSkeleton = styled.div`
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 0;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) => (props.isDoubleGridSingleTile ? `padding-top: 94%` : `padding-top: 180%`)};
    ${(props) => (props.isEspotTile ? `padding-top: 220%` : ``)};
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isEspotTile ? `padding-top: 200%` : ``)};
    ${(props) => (props.isDoubleGridSingleTile ? `padding-top: 105%` : `padding-top: 200%`)};
  }

  @media only screen and (min-width: 1440px) and (max-width: 1920px) {
    ${(props) => (props.isEspotTile ? `padding-top: 174%` : ``)};
    ${(props) => (props.isDoubleGridSingleTile ? `padding-top: 90%` : `padding-top: 170%`)};
  }
  @media only screen and (min-width: 1921px) {
    ${(props) => (props.isEspotTile ? `padding-top: 158%` : ``)};
    ${(props) => (props.isDoubleGridSingleTile ? `padding-top: 80%` : `padding-top: 155%`)};
}
`;

export const ImageSkeleton = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 22px;
  left: 0;
  border-radius: 8px;
  @media ${(props) => props.theme.mediaQuery.large} {
    border-radius: 16px;
    top: 29px;
  }
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const CarouselWrapper = styled.div`
  display: flex;
  gap: 8px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  @media ${(props) => props.theme.mediaQuery.large} {
    gap: 16px;
  }
`;

export const SkeletonSlide = styled.div`
  flex: 1;
  background: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  min-width: min(50%, 150px);
  height: 350px;
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 450px;
    min-width: min(50%, 250px);
  }
`;

export const FullInGridRow = styled.div`
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  ${(props) => getHeightVal(props?.aspectRatioObj, 'MOBILE', 350)}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => getHeightVal(props?.aspectRatioObj, 'TABLET', 400)}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => getHeightVal(props?.aspectRatioObj, 'DESKTOP', 450)}
  }
`;

export const DoubleInGrid = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: 100%;
  gap: 8px;
  @media ${(props) => props.theme.mediaQuery.large} {
    gap: 16px;
  }
`;

export const SkeletonCarouselImage = styled.div`
  width: 100%;
  height: 100%;
  min-height: 340px;
  background: linear-gradient(100deg, #e0e0e0 20%, #f5f5f5 50%, #e0e0e0 80%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const SkeletonItemSlide = styled.div`
  flex: 1;
  height: 185px;
  overflow: hidden;
  position: relative;
  min-width: min(50%, 150px);
  background: ${(props) => props.theme.colorPalette.gray[91]};
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 430px;
    min-width: min(50%, 352px);
  }
`;